
/**
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 1.0.3
 * @copyright  Copyright (C) 2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *    2025-03-19 (1.0.0) (jhoward)
 *      - Refactor the section component loading decision-making to the <section-dispatch> component for both textual and visual display types.
 *
 *  2025-04-09 (1.0.1) (jhoward)
 *    - Add <Easter_defaultSection> to <section-dispatch>.
 *
 *  2025-05-05 (1.0.2) (jhoward)
 *    - Add <MothersDay_defaultSection> to <section-dispatch>.
 *
 *  2025-05-05 (1.0.3) (jhoward)
 *    - Change <ChristmasLibations_defaultSection> to <ChristmasLibations2025_defaultSection>.
 *    - Change <ChristmasDining_defaultSection> to <ChristmasDining2025_defaultSection>.
 *    - Change <Thanksgiving_defaultSection> to <Thanksgiving2025_defaultSection>.
 */
import {defineComponent, PropType} from 'vue';

import DefaultVisualSection from "./visual/defaultVisualSection.vue";
import DefaultTextualSection from "./textual/defaultTextualSection.vue";
import BackBarDefaultSection from "./BackBarDefaultSection.vue";
import BackBarDrinksSection from "./BackBarDrinksSection.vue";
import BackBarDrinksTwoColumnSection from "./BackBarDrinksTwoColumnSection.vue";
import Bimini_defaultSection from "./Bimini_defaultSection.vue";
import Bimini_twoColumnSection from "./Bimini_twoColumnSection.vue";
import Bimini_threeColumnSection from "./Bimini_threeColumnSection.vue";
import Bimini_steakSection from "./Bimini_steakSection.vue";
import Bimini_dessert from "./Bimini_dessert.vue";
import Bimini_wineList from "./Bimini_wineList.vue";
import Bimini_aperitifs from "./Bimini_aperitifs.vue";
import Chi_defaultSection from "./Chi_defaultSection.vue";
import Chi_twoColumnSection from "./Chi_twoColumnSection.vue";
import Chi_threeColumnSection from "./Chi_threeColumnSection.vue";
import HighLimit_defaultSection from "./HighLimit_defaultSection.vue";
import OceanoDefaultSection from "./OceanoDefaultSection.vue";
import OceanoTwoColumnSection from "./OceanoTwoColumnSection.vue";
import OceanoDrinkSection from "./OceanoDrinkSection.vue";
import OceanoSteakSection from "./OceanoSteakSection.vue";
import OceanoDessertSection from "./OceanoDessertSection.vue";
import OceanoAyceSection from "./OceanoAyceSection.vue";
import PanchoWillies_defaultSection from "./PanchoWillies_defaultSection.vue";
import PanchoWillies_drinkSection from "./PanchoWillies_drinkSection.vue";
import PanchoWillies_dessertSection from "./PanchoWillies_dessertSection.vue";
import PanchoWillies_specialtyDrinkSection from "./PanchoWillies_specialtyDrinkSection.vue";
import Romanza_wineList from "./Romanza_wineList.vue";
import Romanza_dessert from "./Romanza_dessert.vue";
import Romanza_dessertWine from "./Romanza_dessertWine.vue";
import Romanza_defaultSection from "./Romanza_defaultSection.vue";
import WvSteakHouseDefaultSection from "./WvSteakHouseDefaultSection.vue";
import WvSteakHouseSteakSection from "./WvSteakHouseSteakSection.vue";
import WvSteakHouseDessertSection from "./WvSteakHouseDessertSection.vue";
import WvSteakHouseTwoColumnSection from "./WvSteakHouseTwoColumnSection.vue";
import WvSteakHouseCocktailSection from "./WvSteakHouseCocktailSection.vue";
import WvSteakHouseWineListSection from "./WvSteakHouseWineListSection.vue";
import Thanksgiving2025_defaultSection from "./Thanksgiving2025_defaultSection.vue";
import NewYears_defaultSection from "./NewYears_defaultSection.vue";
import ChristmasDining2025_defaultSection from "./ChristmasDining2025_defaultSection.vue";
import ChristmasLibations2025_defaultSection from "./ChristmasLibations2025_defaultSection.vue";
import ValentinesDay_defaultSection from "./ValentinesDay_defaultSection.vue";
import Easter_defaultSection from "./Easter_defaultSection.vue";
import MothersDay_defaultSection from "./MothersDay_defaultSection.vue";
import {Menu, MenuSection} from "../defs";

export default defineComponent({
  name: "SectionDispatch",
  components: {
    DefaultVisualSection, DefaultTextualSection,
    Bimini_defaultSection, Bimini_twoColumnSection, Bimini_threeColumnSection, Bimini_steakSection, Bimini_dessert, Bimini_wineList, Bimini_aperitifs,
    Chi_defaultSection, Chi_twoColumnSection, Chi_threeColumnSection,
    HighLimit_defaultSection,
    OceanoDefaultSection, OceanoTwoColumnSection, OceanoDrinkSection, OceanoSteakSection, OceanoDessertSection, OceanoAyceSection,
    PanchoWillies_defaultSection, PanchoWillies_drinkSection, PanchoWillies_dessertSection, PanchoWillies_specialtyDrinkSection,
    Romanza_wineList, Romanza_dessert, Romanza_dessertWine, Romanza_defaultSection,
    WvSteakHouseDefaultSection, WvSteakHouseDessertSection, WvSteakHouseSteakSection, WvSteakHouseTwoColumnSection, WvSteakHouseCocktailSection, WvSteakHouseWineListSection,
    BackBarDefaultSection, BackBarDrinksSection, BackBarDrinksTwoColumnSection,
    Thanksgiving2025_defaultSection,
    NewYears_defaultSection,
    ChristmasDining2025_defaultSection,
    ChristmasLibations2025_defaultSection,
    ValentinesDay_defaultSection,
    Easter_defaultSection,
    MothersDay_defaultSection,
  },
  props: {
    menu: {
      type: Object as PropType<Menu>,
      required: true
    },
    section: {
      type: Object as PropType<MenuSection>,
      required: true
    },
  },
  data() {
    return {
      availableComponents: [
        'BackBarDefaultSection',
        'BackBarDrinksSection',
        'BackBarDrinksTwoColumnSection',
        'Bimini_defaultSection',
        'Bimini_twoColumnSection',
        'Bimini_threeColumnSection',
        'Bimini_steakSection',
        'Bimini_dessert',
        'Bimini_wineList',
        'Bimini_aperitifs',
        'Chi_defaultSection',
        'Chi_twoColumnSection',
        'Chi_threeColumnSection',
        'HighLimit_defaultSection',
        'OceanoDefaultSection',
        'OceanoTwoColumnSection',
        'OceanoDrinkSection',
        'OceanoSteakSection',
        'OceanoDessertSection',
        'OceanoAyceSection',
        'PanchoWillies_defaultSection',
        'PanchoWillies_drinkSection',
        'PanchoWillies_dessertSection',
        'PanchoWillies_specialtyDrinkSection',
        'Romanza_wineList',
        'Romanza_dessert',
        'Romanza_dessertWine',
        'Romanza_defaultSection',
        'WvSteakHouseDefaultSection',
        'WvSteakHouseDessertSection',
        'WvSteakHouseSteakSection',
        'WvSteakHouseTwoColumnSection',
        'WvSteakHouseCocktailSection',
        'WvSteakHouseWineListSection',
        'Thanksgiving2025_defaultSection',
        'NewYears_defaultSection',
        'ChristmasDining2025_defaultSection',
        'ChristmasLibations2025_defaultSection',
        'ValentinesDay_defaultSection',
        'Easter_defaultSection',
        'MothersDay_defaultSection',
      ],
    };
  },
  computed: {
    containerClasses(): {[key: string]: boolean} {
      return {
        'visual_menu--section': this.$store.state.displayType !== 'textual',
        'textual_menu--section': this.$store.state.displayType === 'textual',
      };
    },
    sectionComponentName(): string {
      if (-1 !== this.availableComponents.indexOf(this.section.ms_custom_flipbook_component)) {
        return this.section.ms_custom_flipbook_component;
      }

      return ('textual' === this.$store.state.displayType) ? 'DefaultTextualSection' : 'DefaultVisualSection';
    },
  },
})
